import { render, staticRenderFns } from "./current_mailing_address.vue?vue&type=template&id=9b654c4e&"
import script from "./current_mailing_address.vue?vue&type=script&lang=js&"
export * from "./current_mailing_address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports